export const orderStatus = {
    TRANSFERRING: 'Transferring',
    PROCESSING: 'Processing',
    TRANSFER_FAILED: 'Transfer failed',
    CANCELLED: 'Cancelled',
    CANCELLED_PART: 'Cancelled (Part)',
    DISPATCHED: 'Dispatched',
    DISPATCHED_PART: 'Dispatched (Part)',
    DISPATCHED_CANCEL: 'Dispatched (Canc)',
    CONFIRMED: 'Confirmed',
    CONFIRMED_DISPATCHED_PART: 'Confirmed Dispatched (Part)',
    CONFIRMED_DISPATCHED_CANCEL: 'Confirmed Dispatched (Canc)',
    CANCELLED_CONFIRMED: 'Cancelled Confirmed'
}